import { FiTaskV2ReportAssigneesCellComponent } from '@fi-app/task-v2/fi-task-v2-report/fi-task-v2-report-widget-details/assignees-cell/fi-task-v2-report-assignees-cell.component';

export enum FiTaskReportType {
    All = 0,
    Overdue = 1,
    AssignedByMe = 2,
    ChecklistTasks = 3,
    AssignedToMe = 4,
    Private = 5,
}

export enum FiTaskReportStatusType {
    Overdue = 0,
    NotStarted = 1,
    InProgress = 2,
    Completed = 3,
    Cancelled = 4,
}

export enum FiTaskReportDateType {
    PastWeek = 1,
    PastMonth = 2,
    PastQuarter = 3,
    PastYear = 4,
    Custom = 100,
}

export enum FiTaskOverviewTableColumns {
    AssignedTo = 'AssignedTo',
    UsersAssignees = 'UsersAssignees',
    CreatedOn = 'CreatedOn',
    StartedOn = 'StartedOn',
    Reopened = 'Reopened',
    CompletedOn = 'CompletedOn',
    Overdue = 'Overdue',
    LastReminderDate = 'LastReminderDate',
    ArchivedOn = 'ArchivedOn',
}

export enum FiTaskV2ReportAssigneesCellType {
    ListAssignedTo,
    DetailsAssignedTo,
    DetailsStaffInRolesUnits,
}
